<template>
  <asc-card
    no-spacing
    class="asc-dynamic-counter--container"
    :class="[showLink ? 'link' : 'no-link']"
    flat
  >
    <template v-if="hasData">
      <div @click="handleClick">
        <div
          class="asc-dynamic-counter--container-content"
          :class="getBasicClasses"
        >
          <v-icon
            v-if="icon"
            class="asc-dynamic-counter--container-content icon"
            color="red"
            :size="20"
            >{{ icon }}</v-icon
          >
          <span
            v-if="value"
            class="asc-dynamic-counter--container-content value"
            >{{ value }}</span
          >
          <v-clamp
            class="asc-dynamic-counter--container-content label"
            autoresize
            :max-lines="3"
          >
            {{ label }}
          </v-clamp>
          <span
            v-if="showLink"
            class="asc-dynamic-counter--container-content linkText"
            >{{ linkText }}</span
          >
        </div>
      </div>
    </template>
    <template v-if="!hasData">
      <div class="asc-dynamic-counter--container__noData">
        <span>{{ 'No Data Displayed' }}</span>
      </div>
    </template>
  </asc-card>
</template>

<script>
import VClamp from 'vue-clamp'
import AscCard from '@/components/atoms/AscCard'
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscDynamicCounter',

  components: {
    AscCard,
    VClamp,
  },

  props: {
    label: {
      type: String,
      default: () => '',
    },
    linkText: {
      type: String,
      default: () => 'Go To Mx Rec',
    },
    location: {
      type: String,
      default: () => '',
    },
    value: {
      type: Number,
      default: () => 0,
    },
    icon: {
      type: String,
      default: '',
    },
  },

  computed: {
    getTextColor() {
      return variables.primaryblack
    },
    showLink() {
      return this.location && this.linkText
    },
    hasData() {
      return this.label && this.value
    },
    getBasicClasses() {
      if (this.icon) {
        return 'withIcon'
      } else {
        if (this.showLink) {
          return 'noIcon-link'
        } else {
          return 'noIcon-noLink'
        }
      }
    },
  },

  methods: {
    handleClick() {
      if (this.location) {
        this.$router.push(this.location)
      }
    },
  },
}
</script>

<style lang="scss">
.asc-dynamic-counter {
  &--container {
    display: flex;
    flex-flow: column nowrap;
    height: 100%;
    min-height: 120px;
    width: 100%;
    text-align: center;
    text-transform: uppercase;

    .asc-card__text {
      height: 100%;
    }

    &-content {
      display: flex;
      align-items: center;
      flex-flow: column nowrap;

      &.icon {
        height: 25%;
        align-self: flex-end;
        padding-top: 10px;
        padding-right: 12px;
      }

      &.value {
        color: $primary-black;
        font-size: 32px;
        text-align: center;
        line-height: 38px;
        height: 32px;
      }

      &.label {
        color: $gray-1000;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 1px;
        font-weight: 500;
        text-align: center;
        margin: 3px;
        padding: 0 7px;
      }

      &.withIcon {
        & .value {
          position: absolute;
          top: 27px;
        }

        & .label {
          position: absolute;
          top: 60px;
        }
      }

      &.noIcon {
        &-noLink {
          & .value {
            position: absolute;
            top: 30px;
            padding: 5px;
          }

          & .label {
            height: 56px;
            position: absolute;
            top: 65px;
            padding: 5px;
            margin: 0;
          }
        }

        &-link {
          & .value {
            position: absolute;
            top: 10px;
          }

          & .label {
            height: 56px;
            position: absolute;
            top: 45px;
          }
        }
      }

      & .linkText {
        color: #057874;
        position: absolute;
        bottom: 10px;
        height: 18px;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    &.link {
      &:hover {
        background-color: $accent-0 !important;
        cursor: pointer;

        & .linkText {
          text-decoration: underline;
        }
      }
    }

    &.no-link {
      &:hover {
        cursor: default !important;
      }
    }

    &__noData {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      padding: 12px;

      & > span {
        color: $gray-1000;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 1px;
        line-height: 18px;
        text-align: center;
      }
    }
  }
}
</style>
